import { compact } from "lodash";
import { useTopics } from "@shapeable/ui";
import { sortBy } from "lodash";

export const usePublicationFilters = () => {
  const topics = useTopics();

  return {
    selects: compact([
      {
        name: 'topics',
        items: sortBy(topics, 'outlineNumber'),
        pluralLabel: 'Topics',
      },
    ]),
    typeToggles: [
      { name: 'Topic', label: 'Breakthrough Brief' },
      { name: 'InvitedContribution', label: 'Invited Contributions' },
      { name: 'SenseMaker', label: 'Sense Making' },
      { name: 'EditorialPost', label: 'Editorial' },
      { name: 'LandmarkReport', label: 'Landmark Reports' },
    ]
  };
};